import { render, staticRenderFns } from "./AruszallitoProduct.vue?vue&type=template&id=00503696&scoped=true&"
import script from "./AruszallitoProduct.vue?vue&type=script&lang=js&"
export * from "./AruszallitoProduct.vue?vue&type=script&lang=js&"
import style0 from "./AruszallitoProduct.vue?vue&type=style&index=0&id=00503696&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00503696",
  null
  
)

export default component.exports